export default __webpack_public_path__ + "static/media/publication.60500e97.svg";